import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Item from './Item';

const NotificationsTable = ({ access, notifications, staff, onAction, onToggle }) => {
  const userNotifications = useMemo(
    () => ({
      defaults: notifications?.user?.filter((item) => item?.is_default),
      not_default: notifications?.user?.filter((item) => !item?.is_default),
    }),
    [notifications.user],
  );

  return (
    <>
      <Item access={access} items={userNotifications.defaults} onAction={onAction} onToggle={onToggle} type="noti-user" title="User notifications" />
      <Item
        access={access}
        items={userNotifications.not_default}
        onAction={onAction}
        onToggle={onToggle}
        type="noti-user"
        subTitle="Notifications below can only be received by users with confirmed email addresses or connected to a Telegram bot."
      />
      <Item access={access} items={notifications.staff} onAction={onAction} type="noti-staff" title="Staff notifications" />
      <Item access={access} items={staff} onAction={onAction} type="staff" title="Staff emails" rootClass="settings-notifications__block-staff" />
      {access?.notifications_staff_email_add && (
        <Button onClick={() => onAction('add')} className="settings-notifications__block-staff--btn">
          Add email
        </Button>
      )}
    </>
  );
};

NotificationsTable.propTypes = {
  access: PropTypes.object,
  notifications: PropTypes.object,
  staff: PropTypes.array,
  onAction: PropTypes.func,
  onToggle: PropTypes.func,
};

export default NotificationsTable;
